import { objectWithoutProperties as _objectWithoutProperties } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React, { useMemo } from 'react';
import { DialogTrigger } from 'react-aria-components';
import PopoverContextProvider from './popover-context.esm.js';
import { PopoverCore } from './popover-core.esm.js';
import Dialog from '../dialog/primitives/dialog.esm.js';
import OverlayArrow from '../overlay-arrow/overlay-arrow.esm.js';

var _excluded = ["isOpen", "defaultOpen", "onOpenChange", "className", "children", "showArrow", "color", "radius", "anchorElement", "maxWidth", "padding"];
function PrivatePopover(_ref) {
  var isOpen = _ref.isOpen,
    defaultOpen = _ref.defaultOpen,
    onOpenChange = _ref.onOpenChange;
    _ref.className;
    var children = _ref.children,
    showArrow = _ref.showArrow,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'base' : _ref$color,
    radius = _ref.radius,
    anchorElement = _ref.anchorElement,
    maxWidth = _ref.maxWidth,
    padding = _ref.padding,
    props = _objectWithoutProperties(_ref, _excluded);
  //This has to be memoized, a new jsx prop would incur multiple rerenders on context provider update
  var contextValue = useMemo(function () {
    return {
      color: color,
      padding: padding,
      radius: radius
    };
  }, [color, padding, radius]);

  /*
   * TODO: will look more closely at this in future
   * Our mobile support should be expanded on as shown in: https://github.com/adobe/react-spectrum/blob/main/packages/%40react-spectrum/dialog/src/DialogTrigger.tsx
   * TLDR: Popovers should be modals/trays in mobile, in addition mobile should rely on OnPress instead of onHover for popovers
   */
  return /*#__PURE__*/React.createElement(PopoverContextProvider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement(DialogTrigger, {
    isOpen: isOpen,
    defaultOpen: defaultOpen,
    onOpenChange: onOpenChange
  }, anchorElement, /*#__PURE__*/React.createElement(PopoverCore, props, showArrow && /*#__PURE__*/React.createElement(OverlayArrow, null), /*#__PURE__*/React.createElement(Dialog, {
    maxWidth: maxWidth
  }, children))));
}
function Popover(props) {
  return /*#__PURE__*/React.createElement(PrivatePopover, props);
}

export { Popover, PrivatePopover, Popover as default };
//# sourceMappingURL=popover.esm.js.map
